import React, { Fragment } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Redirect } from 'react-router-dom';
import { useAuthDataContext } from './AuthDataProvider';
import { Icon } from '@material-ui/core';


export default function LogoutButton() {
    const [loggedOut, setLoggedOut] = React.useState(false);
    const { onLogout, user } = useAuthDataContext();

    const logout = () => {
        onLogout();
        setLoggedOut(true)
    };
    return (
        <Fragment>
            {loggedOut ? <Redirect to="/login" push={true} /> : null}
            {user ? <IconButton color="inherit" onClick={logout} >
                <Icon>logout</Icon>
            </IconButton> : null}
        </Fragment>
    )
}